export default {
  BASE_URL: '/fm/invoice/apply',
  api: [
    {
      name: 'list',
      desc: '开票申请列表列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'select',
      desc: '新增申请-选择销售订单',
      method: 'POST',
      path: '/select'
    },
    {
      name: 'invoiceDetailList',
      desc: '绑定进项发票明细列表',
      method: 'GET',
      path: '/invoiceDetailList'
    },
    {
      name: 'submit',
      desc: '提交',
      method: 'POST',
      path: '/submit'
    },
    {
      name: 'audit',
      desc: '审批',
      method: 'POST',
      path: '/audit'
    },
    {
      name: 'detail',
      desc: '明细',
      method: 'GET',
      path: '/detail'
    },
    {
      name: 'invoiceDetailList',
      desc: '绑定进项发票明细列表',
      method: 'GET',
      path: '/invoiceDetailList'
    },
    {
      name: 'exportOrderDetail',
      desc: '导出明细',
      method: 'POST',
      path: '/export/orderDetail'
    },
    {
      name: 'ruleMatch',
      desc: '规则匹配',
      method: 'POST',
      path: '/rule/match'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/outputInvoice/apply.js